// Wealth-milestone narrative beats. On every WealthChange we check whether
// the active kingdom's wealth has crossed an unseen beat's threshold; if so,
// fire the beat once and mark it seen so it never replays.

import { Events, on, emit } from '../ui/eventBus.js'
import { NarrativeBeats } from '../config/balance.js'
import { active, activeId, persist } from './state.js'

export function init() {
  on(Events.WealthChange, ({ wealth }) => check(wealth))
  on(Events.KingdomChange, () => check(active().wealth))
}

function check(wealth) {
  const k = active()
  const beats = NarrativeBeats[activeId()] ?? []
  if (!k.seenBeats) k.seenBeats = {}
  for (const beat of beats) {
    if (k.seenBeats[beat.id]) continue
    if (wealth < beat.threshold) continue
    k.seenBeats[beat.id] = true
    persist()
    emit(Events.NarrativeBeat, { ...beat, kingdom: activeId() })
    break // one beat at a time — let the UI breathe
  }
}
